var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.oneSlide)?_c('div',{staticClass:"main-block"},[_c('SliderWrapper',{attrs:{"slides":_vm.mainBlockSlides}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }